import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-2';
import 'react-select-2/dist/css/react-select-2.css';

class CustomSelectSearchable extends Component {
	constructor (props) {
		super(props);

		if(props.multiple)
		{
			let initial_values = props.values || [];
			initial_values = initial_values.map(i => parseInt(i, 10));

			this.state = {
				internal_values: props.options.filter(item => initial_values.includes(item.value))
			};
		}
		else
		{
			let initial_values = props.values || null;
			this.state = {
				internal_values: initial_values ? props.options.find(item => parseInt(initial_values, 10) === item.value) : null
			}
		}

		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	handleSelectChange (all_selected) {
		const { formName, name, multiple } = this.props;
		const values = multiple ? all_selected.map(i => i.value) : all_selected.value;

		this.setState({ internal_values: all_selected });
		this.props.onSelect(name, values, formName);
	}

	render () {
		return (
			<Select
				name={this.props.name}
				options={this.props.options}
				multi={this.props.multiple}
				disabled={this.props.disabled}
				placeholder={this.props.placeholder}
				noResultsText="Ничего не найдено"
				clearAllText="Очистить"
				clearValueText="Очистить"
				closeOnSelect={false}
				value={this.state.internal_values}
				onChange={this.handleSelectChange}
				delimiter=","
				joinValues={true}
			/>
		)
	}
}

CustomSelectSearchable.propTypes = {
	placeholder: PropTypes.string,
	multiple: PropTypes.bool,
	disabled: PropTypes.bool,
	options: PropTypes.array,
	values: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
	onSelect: PropTypes.func,
	name: PropTypes.string,
	formName: PropTypes.string
}

CustomSelectSearchable.defaultProps = {
	onSelect: () => {},
	multiple: false
}

export default CustomSelectSearchable;



// WEBPACK FOOTER //
// ./components/CustomSelectSearchable.js